module.exports = __webpack_public_path__ + "img/system_slim.4e2e5f6b.png";